import { Center, Flex, Text } from "@chakra-ui/react";

import Error from "../src/components/common/error";
import TopBand from "../src/components/common/topBand";

export default function ShippingPolicy({ errorMessage }) {
  if (errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }

  const TitleContainer = ({ title }) => (
    <Text variant="contactUsBold" mt={5} fontSize="20px">
      {title}
    </Text>
  );
  const DescContainer = ({ mt, desc }) => (
    <Text mt={mt ? mt : 2} variant="descriptionText">
      {desc}
    </Text>
  );

  return (
    <>
      <TopBand title="Shipping Policy" />
      <Center width="100%" bg="light" flexDirection="column">
        <Flex width="100%" bg="white" justifyContent="center">
          <Flex
            my="45px"
            flexDirection="column"
            width={{ base: "90%", "2xl": "1350px" }}
          >
            <DescContainer desc="Last updated: 1st of August 2023" />

            <TitleContainer title="Policy" />
            <DescContainer
              mt={5}
              desc="An order confirmation will be sent to your registered email address within 24 hours of placing your order. In 2-3 business days, we will dispatch your item, and you will then receive a second email with a tracking number and information about the courier service being used."
            />

            <DescContainer
              mt={5}
              desc="It usually takes 3 to 10 days for your order to be delivered. Email us at online@drvasishths.com or give us a call at +91-9998002862 / 9426065439 / 9998005850, if you are having problems with shipping, and we will be pleased to help!"
            />

            <DescContainer
              mt={5}
              desc="If the billing amount is ₹1000 or above, shipping is free. If not, we charge a fixed shipping fee of ₹100 for each order."
            />

            <DescContainer
              mt={5}
              desc="We do not send any orders on Tuesdays because our company, Dr.Vasishth's AyuRemedies, is closed on that day of the week."
            />

            <TitleContainer title="Questions" />
            <DescContainer desc="If you have any questions concerning our shipping policy, please contact us at: online@drvasishths.com." />
          </Flex>
        </Flex>
      </Center>
    </>
  );
}
